import React, { useEffect, useRef } from 'react';
const ARTIST_ID = 'eecdfa14-e209-4a22-b21c-13e5bf560e8c';
const WIDGET_ID = 'seated-55fdf2c0';
const WIDGET_SRC = 'https://widget.seated.com/app.js';
export function SeatedTourWidget({
  className = ''
}: {
  className?: string;
}) {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const script = document.createElement('script');
    script.src = WIDGET_SRC;
    script.async = true;
    document.body.appendChild(script);
    const container = containerRef.current;
    return () => {
      script.remove();
      if (container) {
        container.innerHTML = '';
      }
    };
  }, []);
  return <div className={`rounded-lg bg-white px-5 py-4 text-brand-black ${className}`} data-id="element-90" data-mp="22wwyuseiep6m">
      <div ref={containerRef} id={WIDGET_ID} data-artist-id={ARTIST_ID} data-css-version="3" data-id="element-91" data-mp="1ysz0ijx0diem" />
    </div>;
}